import { api } from 'data/api/api'

import {
  InitiateSingleCheckoutArgs,
  SingleCheckoutResp,
  UpdateSingleCheckoutArgs,
} from '../types/checkout'
import { updateSingleCheckoutDataArgsToParams } from '../transformers/update-checkout'

export const initiateSingleCheckout = ({ id, type }: InitiateSingleCheckoutArgs) =>
  api.post<SingleCheckoutResp>('/purchases/checkout/build', {
    purchase_items: [{ id: Number(id), type }],
  })

export const refreshSingleCheckoutPurchase = (id: string) =>
  api.put<SingleCheckoutResp>(`/purchases/${id}/checkout`, { components: [] })

export const updateSingleCheckoutData = (id: string, args: UpdateSingleCheckoutArgs | undefined) =>
  api.put<SingleCheckoutResp>(
    `/purchases/${id}/checkout`,
    args && updateSingleCheckoutDataArgsToParams(args),
  )
